import { render, staticRenderFns } from "./AddPOS.vue?vue&type=template&id=09b20f64&"
import script from "./AddPOS.vue?vue&type=script&lang=js&"
export * from "./AddPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports